import { A11yMenu2 } from '@barrierefrei/a11y-menu-2';
import { FvCustomEventNames } from '../../ts/events';

/**
 * Friendation component
 * @param component Instance of this _Friendation_ component
 */
const BasisNavigation = (component: HTMLElement) => {
  /** Navigation element */
  const nav = component.querySelector('nav');
  if (!nav) return;

  const myMenu = new A11yMenu2({
    nav
  });

  const basisHeader = document.querySelector('[is="basis-header"]');

  myMenu.onEvent('onReady', () => {
    basisHeader.classList.remove('loading');
  });

  /** When the header closes, the navigation closes */
  document.addEventListener(FvCustomEventNames.BasisHeaderOut, () => {
    myMenu.closeAll();
  });
};

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-navigation"]';

/** Function that handles a single instance of this _Friendation_ component */
const classFunction: (component: HTMLElement) => void = BasisNavigation;

/**
 * Friendation component
 */
export const aBasisNavigation = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((x) => {
    classFunction.call(this, x);
  });
};
